// Module
var code = "<script>let $ctrl</script> <div class=\"pb-1 border-b molecule-panel-edit-row molecule-panel-edit-row-headline\"> <atom-text modifier=\"subheadline\"> <ng-transclude></ng-transclude> </atom-text> </div> ";
// Exports
module.exports = code;